import React from 'react';
import { 
  HelpCircle, 
  Dumbbell, 
  Utensils, 
  Scale, 
  Clock, 
  Heart, 
  Percent, 
  Activity 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Dumbbell,
      title: 'Силовые тренировки',
      description: 'Тренировки с отягощениями помогают сохранить и нарастить мышечную массу, что увеличивает метаболизм.'
    },
    {
      icon: Utensils,
      title: 'Здоровое питание',
      description: 'Увеличьте потребление белка (1.6-2.2г на кг веса) для поддержания мышечной массы при снижении веса.'
    },
    {
      icon: Activity,
      title: 'Кардио тренировки',
      description: 'Добавьте 2-3 кардио тренировки в неделю для ускорения сжигания жира и улучшения сердечно-сосудистой системы.'
    },
    {
      icon: Scale,
      title: 'Темп снижения веса',
      description: 'Оптимальная скорость снижения веса – 0.5-1% от массы тела в неделю, чтобы сохранить мышечную массу.'
    },
    {
      icon: Clock,
      title: 'Здоровый сон',
      description: 'Сон 7-9 часов важен для восстановления, гормонального баланса и контроля аппетита.'
    },
    {
      icon: Percent,
      title: 'Оптимальный процент жира',
      description: 'Для мужчин здоровый диапазон – 10-20%, для женщин – 18-28%, в зависимости от возраста и активности.'
    },
    {
      icon: Heart,
      title: 'Регулярность измерений',
      description: 'Отслеживайте свой прогресс раз в 2-4 недели, а не ежедневно, чтобы видеть реальные тенденции.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по улучшению состава тела
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Консультация специалиста
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Для создания индивидуального плана по улучшению состава тела рекомендуется консультация диетолога и тренера.
            </p>
            <a 
              href="https://navigator.fpmr.ru/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full py-1.5 px-3 text-xs bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors inline-block text-center"
            >
              Найти специалиста
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;